<div class="actions">
  <div class="overlap-group3">
    <div class="group">
      <ng-container *ngFor="let action of actions">
        <div class="action-group">
          <ng-container>
            <div class="icon-container">
              <img class="action-icons" [src]="action.icon" />
            </div>
          </ng-container>
          <div class="text-container" (click)="onClickAction(action)">
            <span class="opensans-normal-sapphire-14px">
              {{ action.viewValue }}
            </span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
